import { FC } from 'react'
import { List } from 'antd'
import Product, { IProduct } from './product'

interface ListProductsProps {
  products: IProduct[]
  hanleSelect?: (value: string) => void
  hanleDelete?: (value: string) => void
}

const ListProducts: FC<ListProductsProps> = ({ products, hanleSelect, hanleDelete }) => {
  return (
    <List
      itemLayout='horizontal'
      dataSource={products}
      renderItem={(product) => <Product product={product} hanleDelete={hanleDelete} hanleSelect={hanleSelect} />}
    />
  )
}

export default ListProducts
